import { Big } from "big.js";
import React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { AppState } from "../../RootReducer";
import { PriorityType } from "../../http/Types";
import { CurrencyDefinition, PaymentMethod, PaymentType, PlayerOrder, WithdrawContext } from "../../http/protocol";
import { t } from "../../i18n";
import { getContainer } from "../../ioc/IOCSetup";
import { WithdrawState } from "../../payments/PaymentsReducer";
import { initWithdraw, updateOrderCustom } from "../../payments/WithdrawActions";
import CurrencyFormatter from "../../utils/CurrencyFormatter";
import "../Withdraw.scss";
import { BrandA } from "../buttons/buttons";
import { OpenInNewWindow, PaymentBroadcaseMessage } from "../deposit/OpenInNewWindow";


interface Props  {
    updateAddress? : (recipientAddress : string) => void,
    initWithdraw? : ()=>void;
    updateOrderCustom?: (data: any) => void,
    recipientAddress?:string;
    amount?: string;
    currency?: string;
    confirmedStatus?:boolean;
    currencies?: Array<CurrencyDefinition>;
    activeMethod?: PaymentMethod;
    withdraw: WithdrawState;
    withdrawContext : WithdrawContext;
    priority : PriorityType;
    orderCustom? : any;
    destinationTag?: string;
}

interface State {
    authorizing: boolean,
    authorizeUrl?: string
}

export class MayaConfirmWithdraw extends React.Component<Props,State> {
    constructor(props : Props) {
        super(props);

        let authUrl = this.props.withdrawContext!.providerProperties!['clientAuthUrl']
        authUrl = authUrl.replace("emailOrPhone", this.props.orderCustom.profileId);

        this.state = {authorizing: true, authorizeUrl: authUrl};
    }

    getCurrency() {
        let currency = this.props.currencies && this.props.currencies.find((currencyDef: CurrencyDefinition) => {
            if(this.props && this.props.currency && currencyDef.code == this.props.currency) {
                return true;
            }
        });
        return currency;
    }

    callback(msg: PaymentBroadcaseMessage) {
        const uid = msg.context.requestUid
        const token = msg.context.token
        this.props.updateOrderCustom?.(msg.context)
        this.props.initWithdraw?.()
    }



    render() {
        let wc = this.props.withdrawContext;
        console.log(this.props.orderCustom, wc.customContext);
        return (
            <div className={"confirm-withdraw-container"}>
                <div className={"confirm-withdraw-header"}>
                    <span className={"confirm-withdraw-title"}>{t("withdrawPage.verifyPhaseTitle")}</span>
                    <span className={"confirm-withdraw-subTitle"}>{t("payment.form.mayaprincipal.confirm-subtitle")}</span>
                </div>
                <div className={"withdraw-summary"}>
                    <div className={"payout"}>
                        {this.props.orderCustom && wc?.inputs && (
                            wc.inputs.map((i : any) => (
                                <div className={"amountContainer"} key={i.name}>
                                    <span className={"methodName"}>{t(`payment.form.${i.name}.confirm-label`)}</span>
                                    {i.type == "SELECT" && <span className={"email"}>{t(`payment.form.${i.name}.opt-${this.props.orderCustom[i.name]}`)}</span>}
                                    {i.type != "SELECT" && <span className={"email"}>{this.props.orderCustom[i.name]}</span>}


                                </div>
                            ))
                        )}
                        {(!wc?.inputs || wc?.inputs.length == 0) && (
                           <>
                               <div className={"amountContainer"}>
                                   <span className={"methodName"}>{`${this.props.activeMethod && this.props.activeMethod.name && this.props.activeMethod.name} ${t("payments.account")}`}</span>
                                   <span className={"email"}>{this.props.recipientAddress}</span>
                               </div>
                               {this.props.destinationTag && this.props.destinationTag.length > 0 && (
                                   <div className={"amountContainer"}>
                                       <span className={"methodName"}>{t("payments.destination-tag")}</span>
                                       <span className={"email"}>{this.props.destinationTag}</span>
                                   </div>
                               )}
                           </>
                        )}

                        <div className={"amountContainer"}>
                            <span className={"amountLabel"}>{t("withdrawPage.verifyPhaseText1")}</span>
                            <span className={"amount"}>{this.props.amount && CurrencyFormatter.formatWithSymbol(this.getCurrency(), new Big(this.props.amount))}</span>
                        </div>
                    </div>
                </div>

                <div className={"summaryContainer"} />

                { this.state.authorizing  &&  this.state.authorizeUrl  &&   
                    <OpenInNewWindow url={this.state.authorizeUrl} callback={(d) => this.callback(d)}/>
                }


            </div>
        )
    }


}
const mapStateToProps = (app : AppState)=> {
    return {
        withdraw: app.payments.withdraw,
        activeMethod: app.payments.withdraw.activeMethod,
        currency : app.payments.withdraw.activeCurrency,
        amount : app.payments.withdraw.amount,
        recipientAddress : app.payments.withdraw.recipientAddress,
        destinationTag : app.payments.withdraw.destinationTag,
        currencies: app.user.user != undefined ? app.user.user.currencies : undefined,
        withdrawContext : app.payments.withdraw.withdrawContext,
        priority : app.payments.withdraw.priority,
        orderCustom : app.payments.withdraw.orderCustom
    }
};
const mapDispatchToProps = (dispatch: Dispatch)=> ({
    initWithdraw : () => dispatch(initWithdraw() as any),
    updateOrderCustom: (data: any) => dispatch(updateOrderCustom(data))
});

export default connect(mapStateToProps,mapDispatchToProps)(MayaConfirmWithdraw as any);